import { css } from '@microsoft/fast-element';
import { gridLayoutRWDStyles } from './responsiveness';
export const foundationGridLayoutStyles = css `
  slot {
    width: 100%;
    height: 100%;
    display: grid;
  }

  ${gridLayoutRWDStyles()}
  ${gridLayoutRWDStyles('lg')}
  ${gridLayoutRWDStyles('md')}
  ${gridLayoutRWDStyles('sm')}
`;
